




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SystemConst from "@/config/const";
import TicketFavoriteService from "@/services/TicketFavoriteService";

@Component
export default class TicketTipComponent extends Vue {
  isDisabledFav = false;
  isSecretSale = false;
  @Prop({ default: {} })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pTicketUser!: any;

  @Prop({ default: false })
  pUnFavMode!: boolean;

  SystemConst = SystemConst;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pTicket: any;
  faved = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get parent(): any {
    return this.$parent;
  }

  get ticketType() {
    let val: any;
    if (this.pTicketUser.type === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      if (this.pTicketUser.available_count > 1) {
        val = SystemConst.TICKET_SERVICE_TYPE_MULTIPLE;
      } else {
        val = SystemConst.TICKET_SERVICE_TYPE_ONEC;
      }
    } else {
      val = this.pTicketUser.type;
    }
    return val;
  }

  get ticketTypeText() {
    let val = "";
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "定額(サブスク)サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_ONEC) {
      val = "単品サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      val = "回数券サービス";
    }
    return val;
  }

  async fav() {
    if (this.isDisabledFav) return;
    this.isDisabledFav = true;
    await TicketFavoriteService.createTicket({
      ticket_id: this.pTicket.id,
    }).then((rsp: any) => (this.faved = true));
    this.isDisabledFav = false;
  }

  async unFav() {
    if (this.isDisabledFav) return;
    this.isDisabledFav = true;
    this.faved = false;
    await TicketFavoriteService.deleteTicket(this.pTicket.id).then((rsp: any) => (this.faved = false));
    this.isDisabledFav = false;
  }

  async favedStatus() {
    const {
      data: { ticket_favorite },
    } = await TicketFavoriteService.getTicket(this.pTicket.id);
    this.faved = !!ticket_favorite;
  }

  public created() {
    this.pTicket = this.pTicketUser.ticket;
    this.favedStatus();
    if (this.pTicketUser.sale_method === SystemConst.PURCHASED_TICKET_SECRET_SALE){
      this.isSecretSale = true
    }
  }
}
